import { Box, Button, Divider, Grid, ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material"
import { styled } from "@mui/material/styles"
import PaperBox from "components/PaperBox"
import LoadingBox from "components/skeleton/LoadingBox/LoadingBox"
import LoadingTypography from "components/skeleton/LoadingTypography"
import { LoadingTextCell } from "./TextCell"

import { faCheck } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const StyledDiv = styled("div")(({ theme }) => ({
  position: "relative"
}))

const StyledGridBetween = styled(Grid)(({ theme }) => ({
  justifyContent: "space-between",
  "& .MuiGrid-item": {
    minWidth: 125
  }
}))
const StyledGridFlexStart = styled(Grid)(({ theme }) => ({
  justifyContent: "flex-start",
  "& .MuiGrid-item": {
    minWidth: 125
  }
}))
const StyledGridOverlayText = styled(Grid)(({ theme }) => ({
  position: "absolute",
  width: "100%",
  height: "100%",
  "& > div": {
    maxWidth: "500px",
    zIndex: 1,
    padding: 15
  }
}))
const StyledList = styled(Grid)(({ theme }) => ({
  "& .MuiListItem-root:hover": {
    color: "rgba(0, 0, 0, 0.87)"
  }
}))

const Section = () => {
  return (
    <Box marginBottom={3}>
      <StyledGridBetween container direction="row" spacing={2}>
        <Grid item xs={6}>
          <LoadingTypography variant="h4" />
        </Grid>
      </StyledGridBetween>
      <StyledGridBetween container direction="row" spacing={2}>
        <Grid item>
          <LoadingTextCell />
        </Grid>
        <Grid item>
          <LoadingTextCell />
        </Grid>
        <Grid item>
          <LoadingTextCell />
        </Grid>
        <Grid item>
          <LoadingTextCell />
        </Grid>
        <Grid item>
          <LoadingTextCell />
        </Grid>
      </StyledGridBetween>
    </Box>
  )
}

const LoadingTabs = ({ noAnimate }) => {
  return (
    <StyledDiv>
      {!noAnimate && (
        <StyledGridFlexStart container direction="row" spacing={6}>
          <Grid item md={2}>
            <LoadingBox width={"100%"} height={25} />
          </Grid>
          <Grid item md={2}>
            <LoadingBox width={"100%"} height={25} />
          </Grid>
          <Grid item md={2}>
            <LoadingBox width={"100%"} height={25} />
          </Grid>
        </StyledGridFlexStart>
      )}
      {noAnimate && (
        <StyledGridOverlayText container direction="column" justifyContent="center" alignItems="center">
          <Grid item>
            <PaperBox>
              <Typography variant="h2" gutterBottom>
                Lås upp integration mot Transportstryrelsen
              </Typography>
              <Typography variant="bodyMedium">Ta del av fördelarna med Transportstyrelsedata</Typography>
              <StyledList dense={true} disabled>
                <ListItem>
                  <ListItemIcon>
                    <FontAwesomeIcon icon={faCheck} />
                  </ListItemIcon>
                  <ListItemText primary="Vilka fordon som har körförbud" />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <FontAwesomeIcon icon={faCheck} />
                  </ListItemIcon>
                  <ListItemText primary="Vilka fordon ska besiktigas inom 14 dagar" />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <FontAwesomeIcon icon={faCheck} />
                  </ListItemIcon>
                  <ListItemText primary="Använd data från Transportstyrelsen i dina rapporter" />
                </ListItem>
              </StyledList>
              <Box marginBottom={2}>
                <Divider />
              </Box>

              <Button variant="contained" color="primary" href="mailto:info@cloudplanning.se">
                Kontakta oss
              </Button>
            </PaperBox>
          </Grid>
        </StyledGridOverlayText>
      )}
      <Grid container direction="row">
        <Grid item md={12}>
          <PaperBox mt={1}>
            <Grid container direction="row" spacing={5}>
              <Grid item md={8}>
                <StyledGridBetween container direction="row" spacing={2}>
                  <Grid item>
                    <LoadingTextCell noAnimate={noAnimate} />
                  </Grid>
                  <Grid item>
                    <LoadingTextCell noAnimate={noAnimate} />
                  </Grid>
                  <Grid item>
                    <LoadingTextCell noAnimate={noAnimate} />
                  </Grid>

                  <Grid item>
                    <LoadingTextCell noAnimate={noAnimate} />
                  </Grid>
                  <Grid item>
                    <LoadingTextCell noAnimate={noAnimate} />
                  </Grid>
                  <Grid item>
                    <LoadingTextCell noAnimate={noAnimate} />
                  </Grid>
                  <Grid item>
                    <LoadingTextCell noAnimate={noAnimate} />
                  </Grid>
                  <Grid item>
                    <LoadingTextCell noAnimate={noAnimate} />
                  </Grid>
                </StyledGridBetween>
              </Grid>
              <Grid item md={4}>
                <Box bgcolor="background.light" padding={3}>
                  <StyledGridBetween container direction="row" spacing={2}>
                    <Grid item>
                      <LoadingTextCell noAnimate={noAnimate} />
                    </Grid>
                    <Grid item>
                      <LoadingTextCell noAnimate={noAnimate} />
                    </Grid>
                    <Grid item>
                      <LoadingTextCell noAnimate={noAnimate} />
                    </Grid>
                  </StyledGridBetween>
                </Box>
              </Grid>
            </Grid>
            <Section />
            <Section />
            <Section />
          </PaperBox>
        </Grid>
      </Grid>
    </StyledDiv>
  )
}

export default LoadingTabs
